module.exports = __webpack_public_path__ + "static/img/service_item_bg.07cfa2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service_item_bg.png
// module id = Lj9n
// module chunks = 12